import React from "react";
import { Layout } from "antd";

import { BrowserRouter as Router } from "react-router-dom";

import Header from "./components/Header";
import Content from "./containers/Content";

import "./App.scss";

const App = (props) => {
  return (
    <Router>
      <div className="app-container" style={{ minHeight: "100vh" }}>
        <Header />
        <Layout className="app-container--layout">
          <Content></Content>
        </Layout>
      </div>
    </Router>
  );
};

export default App;
